import type { FC } from 'react';
import { TableRow } from '@mui/material';

import type { SurveyListItem } from 'src/types/survey';
import type { Columns } from 'src/components/survey/SurveySelectionPage/components/SurveyTableView/types';

import AdditionalInformationCell from './components/AdditionalInformationCell';
import FavoriteCell from './components/FavoriteCell';
import GoToSurveyCell from './components/GoToSurveyCell';
import NotificationCell from './components/NotificationCell';
import ProjectCategoryNameCell from './components/ProjectCategoryNameCell';
import ProjectNameCell from './components/ProjectNameCell';
import QuestionnaireCell from './components/QuestionnaireCell';
import SurveyNameCell from './components/SurveyNameCell';

import { styles } from './index.styles';

interface SurveyTableRowProps {
  survey: SurveyListItem;
  columns: Columns;
}

const SurveyTableRow: FC<SurveyTableRowProps> = ({ survey, columns }) => (
  <TableRow hover key={survey.id} sx={styles.tableRow}>
    <NotificationCell columns={columns} survey={survey} />
    <SurveyNameCell columns={columns} survey={survey} />
    <ProjectNameCell columns={columns} survey={survey} />
    <ProjectCategoryNameCell columns={columns} survey={survey} />
    <QuestionnaireCell columns={columns} survey={survey} />
    <AdditionalInformationCell columns={columns} survey={survey} />
    <GoToSurveyCell columns={columns} survey={survey} />
    <FavoriteCell columns={columns} survey={survey} />
  </TableRow>
);

export default SurveyTableRow;
